import { PortfolioChild, WebUserDataConstants } from '@ddt-web/domain';
import { PartnerConstants } from '@ddt-web/user-data';
import * as get from 'lodash/get';
import * as toUpper from 'lodash/toUpper';

import { EntityFlags } from './entity-flags';
import { PartnerPortfolioFlagUtils } from './partner-portfolio-flag-utils';


export class PartnerPortfolioUtil {
	/**
	 * Checks if the provided portfolioId is a partner portfolio id.
	 *
	 * @param portfolioId
	 * @returns true if portfolio is partner portfolio, otherwise false
	 */
	public static isPartnerPortfolio(portfolioId: string): boolean {
		return portfolioId && portfolioId.includes(PartnerConstants.PARTNER.PARTNER_IDENTIFIER);
	}

	public static getPartnerPortfolioId(portfolioId: string): string {
		return portfolioId.replace(PartnerConstants.PARTNER.PARTNER_IDENTIFIER, '');
	}

	public static getPartnerCustomAttributes(originalPortfolio: PortfolioChild): { [fieldName: string]: any } {
		if (!originalPortfolio) {
			console.error('Invalid portfolio passed in');
			return {};
		}
		const baseModelId = this.getPartnerPortfolioId(get(originalPortfolio, 'otherIdentifiers[0].identifier', ''));
		if (!baseModelId) {
			console.error('Could not find base model id', baseModelId);
			return {};
		}

		const baseModel = PartnerConstants.PARTNER.PARTNER_IDENTIFIER + baseModelId;

		return {
			baseModel,
			baseModelType: get(originalPortfolio, 'originPlatform.platform'),
			baseModelName: get(originalPortfolio, 'description'),
			baseModelWasDirty: PartnerPortfolioFlagUtils.isModelDirty(get(originalPortfolio, 'flags') as EntityFlags),
			parentDateLastModified: get(originalPortfolio, 'dateLastModified'),
			originPlatform: {
				programHandle: get(originalPortfolio, 'originPlatform.programHandle'),
				riskHandle: get(originalPortfolio, 'originPlatform.riskHandle')
			},
			flags: {
				originContainsEditableModel: get(originalPortfolio, 'flags.originContainsEditableModel', true)
			}
		};
	}

	/**
	 * Sets otherIdentifier to the provided originalPortfolio to mark the portfolio has been successfully exported to the platform as new portfolio.
	 * 
	 * @param originalPortfolio 
	 * @param platformName 
	 * @param platformIdentifier id of the new partner portfolio
	 */
	public static updateOtherIdentifiersToPortfolio(originalPortfolio: any, platformName: string, platformIdentifier: string): any {
		return {
			...originalPortfolio,
			otherIdentifiers: [
				{
					customIdentifierType: toUpper(platformName) + PartnerConstants.CUSTOM_IDENTIFIER_TYPE_SUFFIX,
					identifier: platformIdentifier,
					identifierType: WebUserDataConstants.IDENTIFIER_TYPE.CUSTOM
				}
			]
		};
	}
}
